import controller from './template-detail.controller';
import template from './template-detail.view.html';

let TemplateDetailComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default TemplateDetailComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/templates/template-detail/template-detail.component.js
 **/